import styled, { css } from 'styled-components';

const getBorder = (props) => {
  if (!props.isOuter) {
    return css`
      border-radius: 4px;
      border: 2px solid
        ${(props) =>
          !props.dragEntered
            ? props.groupColor || props.theme.colors.light_darker_1
            : props.theme.colors.dark_lighter};
    `;
  }

  return ``;
};

const handleWires = (props) => {
  if (props.showWire) {
    if (props.position === 'bottom-top') {
      return css`
        &:not(:first-child):before {
          content: '';
          border-left: 2px solid
            ${props.wireColor || props.theme.colors.light_darker_1};
          position: absolute;
          left: 33px;
          height: 15px;
          width: 8px;
          top: -15px;
        }

        &:not(:last-child):after {
          content: '';
          border-left: 2px solid
            ${props.wireColor || props.theme.colors.light_darker_1};
          position: absolute;
          left: 33px;
          height: 15px;
          width: 8px;
          top: 100%;
        }
      `;
    }
    return css`
      &:before {
        content: '';
        height: calc(50% - 2px);
        width: 8px;
        border-bottom: 2px solid
          ${(props) => props.wireColor || props.theme.colors.light_darker_1};
        position: absolute;
        left: -9px;
        top: 0;
      }

      &:last-child:after {
        content: '';
        height: calc(50%);
        width: 9px;
        background-color: white;
        position: absolute;
        left: -10px;
        bottom: 0;
        z-index: 2;
      }
    `;
  }
};

const StyledQueryGroup = styled.div`
  position: relative;
  padding: 0 ${(props) => (!props.isOuter ? props.theme.spacing.small : '0')};
  min-height: 85px;

  ${(props) => getBorder(props)};

  button.button-smaller {
    padding: ${(props) => props.theme.spacing.xsmall}
      ${(props) => props.theme.spacing.small};
    font-size: ${(props) => props.theme.size.small};
    height: auto;

    i svg {
      width: ${(props) => props.theme.size.small};
      height: ${(props) => props.theme.size.small};
    }
  }
  margin-bottom: ${(props) =>
    props.isFirstGroupsChild ? '15px' : props.theme.spacing.small}
  margin-top: ${(props) => props.isFirstGroupsChild && '15px'}
`;

const StyledQueryGroupHeader = styled.div`
  padding-top: ${(props) => props.theme.spacing.small};
  padding-bottom: ${(props) => props.theme.spacing.small};
  button.button-smaller {
    padding: 4px 8px;
    font-size: 12px;

    i svg {
      width: 12px;
      height: 12px;
    }
  }
`;

const StyledQueryGroupEntityList = styled.div`
  padding-left: ${(props) => (props.hasWires ? props.theme.spacing.medium : 0)};
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StyledQueryGroupEntityWires = styled.div`
  position: absolute;
  left: 0;
  margin-top: -8px;
  width: ${(props) => props.theme.spacing.medium};

  height: 100%;

  &:before {
    content: '';
    height: 100%;
    border-left: 2px solid
      ${(props) => props.wiresColor || props.theme.colors.light_darker_1};
    position: absolute;
    right: 8px;
    top: 0;
  }
`;

const StyledQueryEntityWire = styled.div`
  ${(props) => handleWires(props)};

  position: relative;
`;

const StyledIsDraggingPointerEvents = styled.div`
  position: absolute;

  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: ${(props) =>
    props.entityDragging && !props.isOuter ? 'block' : 'none'};
  z-index: 2;
`;

const StyledEmptyGroupText = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 0px 10px 0px;
`;
export {
  StyledQueryGroup,
  StyledQueryGroupHeader,
  StyledQueryGroupEntityList,
  StyledQueryGroupEntityWires,
  StyledQueryEntityWire,
  StyledIsDraggingPointerEvents,
  StyledEmptyGroupText,
};
